module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFormVisible = true
      }
    }
  }, [_vm._v("Add warehouse")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouses,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "warehouseNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address",
      "width": "400px",
      "formatter": _vm.formatAddress
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zipCode",
      "label": "Zip Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "admin",
      "label": "Admin"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getWarehousesById(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteWarehouses(scope.row.warehouseNo)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add warehouse",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehouseForm",
    attrs: {
      "model": _vm.warehouseForm,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.address),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "address", $$v)
      },
      expression: "warehouseForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.city),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "city", $$v)
      },
      expression: "warehouseForm.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.state),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "state", $$v)
      },
      expression: "warehouseForm.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "zipCode", $$v)
      },
      expression: "warehouseForm.zipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Addr Key Wold",
      "prop": "transferAddrKeyWold"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.warehouseForm.transferAddrKeyWold),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "transferAddrKeyWold", $$v)
      },
      expression: "warehouseForm.transferAddrKeyWold"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Physical Addr Key",
      "prop": "physicalAddrKey"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "物理仓库地址关键词，用于混寄包裹跨神医认领匹配"
    },
    model: {
      value: (_vm.warehouseForm.physicalAddrKey),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "physicalAddrKey", $$v)
      },
      expression: "warehouseForm.physicalAddrKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Admin",
      "prop": "adminNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.warehouseForm.adminNo),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "adminNo", $$v)
      },
      expression: "warehouseForm.adminNo"
    }
  }, _vm._l((_vm.adminList), function(admin, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": admin.userNo,
        "label": admin.username
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Visible",
      "prop": "hide"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.warehouseForm.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "isVisiable", $$v)
      },
      expression: "warehouseForm.isVisiable"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.warehouseForm.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.warehouseForm, "isVisiable", $$v)
      },
      expression: "warehouseForm.isVisiable"
    }
  }, [_vm._v("Hide")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addWarehouse.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit warehouse",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editWarehouseObj",
    attrs: {
      "model": _vm.editWarehouseObj,
      "label-width": "180px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State",
      "prop": "state"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.state),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "state", $$v)
      },
      expression: "editWarehouseObj.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.city),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "city", $$v)
      },
      expression: "editWarehouseObj.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.address),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "address", $$v)
      },
      expression: "editWarehouseObj.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zip Code",
      "prop": "zipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "zipCode", $$v)
      },
      expression: "editWarehouseObj.zipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transfer Addr Key Wold",
      "prop": "transferAddrKeyWold"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editWarehouseObj.transferAddrKeyWold),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "transferAddrKeyWold", $$v)
      },
      expression: "editWarehouseObj.transferAddrKeyWold"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Physical Addr Key",
      "prop": "physicalAddrKey"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "物理仓库地址关键词，用于混寄包裹跨神医认领匹配"
    },
    model: {
      value: (_vm.editWarehouseObj.physicalAddrKey),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "physicalAddrKey", $$v)
      },
      expression: "editWarehouseObj.physicalAddrKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Admin",
      "prop": "adminNo"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.editWarehouseObj.adminNo),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "adminNo", $$v)
      },
      expression: "editWarehouseObj.adminNo"
    }
  }, _vm._l((_vm.adminList), function(admin, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": admin.userNo,
        "label": admin.username
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Visible",
      "prop": "isVisiable"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.editWarehouseObj.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "isVisiable", $$v)
      },
      expression: "editWarehouseObj.isVisiable"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.editWarehouseObj.isVisiable),
      callback: function($$v) {
        _vm.$set(_vm.editWarehouseObj, "isVisiable", $$v)
      },
      expression: "editWarehouseObj.isVisiable"
    }
  }, [_vm._v("Hide")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editWarehouse.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-166a8c24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/doctor/warehouse.vue
// module id = 813
// module chunks = 1